jQuery(document).ready(function() {
    var requiredLabel = "{f:translate(key:'LLL:EXT:lpcircet/Resources/Private/Language/locallang.xlf:tx_lpcircet_domain_model_subscribers.error.1221560718', default:'')}";
    var invalidEmailLabel = "{f:translate(key:'LLL:EXT:lpcircet/Resources/Private/Language/locallang.xlf:tx_lpcircet_domain_model_subscribers.error.1221559976', default:'')}";
    $(".newsletter-form").each(function() {
        var validator = $(this).validate({
            messages: {
                "tx_lpcircet_subscribers[newSubscribers][nom]": {
                    required: requiredLabel,
                },
                "tx_lpcircet_subscribers[newSubscribers][prenom]": {
                    required: requiredLabel,
                },
                "tx_lpcircet_subscribers[newSubscribers][email]": {
                    required: requiredLabel,
                    email: invalidEmailLabel
                },
            }
        });
    });
});